// extracted by mini-css-extract-plugin
export default {"mainBanner":"HeroBanner_mainBanner__T3qu9"};